import React, { createContext, useContext, useState, ReactNode } from 'react';

// エラーコンテキスト型
interface ErrorContextValue {
  setError: (message: string | null) => void;
}

// コンテキストの作成
const ErrorContext = createContext<ErrorContextValue | undefined>(undefined);

// エラープロバイダー
export const ErrorProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [error, setError] = useState<string | null>(null);

  return (
    <ErrorContext.Provider value={{ setError }}>
      {error && <ErrorToast message={error} onClose={() => setError(null)} />}
      {children}
    </ErrorContext.Provider>
  );
};

// コンテキストを利用するカスタムフック
export const useError = () => {
  const context = useContext(ErrorContext);
  if (!context) {
    throw new Error('useError must be used within an ErrorProvider');
  }
  return context;
};

// 高階関数 for エラー処理
export const withErrorHandling = (fn: () => Promise<void>, setError: (message: string | null) => void) => {
  return async () => {
    try {
      await fn();
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : '不明なエラーが発生しました。';
      setError(errorMessage);
      console.error(error);
    }
  };
};

// トーストメッセージコンポーネント
const ErrorToast: React.FC<{ message: string; onClose: () => void }> = ({ message, onClose }) => (
  <div
    style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      backgroundColor: '#7A7A7AF7',
      color: '#FFFFFF',
      padding: '10px 20px',
      fontSize: '16px',
      textAlign: 'center',
      zIndex: 1000,
      animation: 'fadeInOut 5s ease-in-out',
    }}
    onAnimationEnd={onClose}
  >
    {message}
    <style>
      {`
        @keyframes fadeInOut {
          0% { transform: translateY(-100%); opacity: 0; }
          10% { transform: translateY(0); opacity: 1; }
          90% { transform: translateY(0); opacity: 1; }
          100% { transform: translateY(-100%); opacity: 0; }
        }
      `}
    </style>
  </div>
);
